<div class="ki-laeuft" role="status" aria-live="polite" data-testid="ki-laeuft">
  <span class="ki-laeuft__spinner" aria-hidden="true"></span>
  <span class="ki-laeuft__text">
    <strong>{{ aktion() }}</strong>
    {{ 'ki.laeuft.hinweis' | translate }}
  </span>
</div>
